<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-3">
            <select v-model="selectedSite" class="form-control">
              <option v-for="(site, index) in sites" :value="index">{{ site }}</option>
            </select>
          </div>
          <div class="col-md-7">
            <div class="form-check">
              <input class="form-check-input" type="radio" name="options" id="exampleRadios1" value="1" v-model="storeRequest">
              <label class="form-check-label" for="exampleRadios1">
                Весь ассортимент
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="options" id="exampleRadios2" value="2" v-model="storeRequest">
              <label class="form-check-label" for="exampleRadios2">
                ТОЛЬКО препараты которые на момент формирования файла есть на (ЦС, МСК) складах
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="options" id="exampleRadios3" value="3" v-model="storeRequest">
              <label class="form-check-label" for="exampleRadios3">
                ТОЛЬКО препараты которые на момент формирования файла есть на (МСК) складах
              </label>
            </div>
          </div>
          <div class="col-md-2">
            <vue-ladda @click="getDrugsFromSite()" button-class="btn btn-sm btn-info"
                       data-style="zoom-in"
                       :loading="loading">Загрузить
            </vue-ladda>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="loading || drugs">
      <div class="card-body">
        <div class="text-center">
          <pulse-loader :loading="loading" :color="color" class="text-center"/>
        </div>
        <div v-if="drugs">

          <div class="row">
            <div class="col-md-4 offset-8">
              <template v-if="exportTypes">
                <div class="input-group m-b-10">
                  <select class="form-control" v-model="exportType">
                    <option v-for="(ext, val) in exportTypes" :value="val">{{ ext }}</option>
                  </select>
                  <div class="input-group-append">
                    <button class="btn btn-success" @click="exportExcelToFile">Выгрузить</button>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <table class="table table-hover">
            <thead>
            <th></th>
            <th>ID</th>
            <th>Препарат</th>
            <th>Приоритет</th>
            <th>Наличие</th>
            <th>Link</th>
            </thead>
            <tbody>
            <tr v-for="(drug, index) in sortBy(drugs)">
              <td>{{ index + 1 }}</td>
              <td>{{ drug.id }}</td>
              <td>{{ drug.drug }}</td>
              <td>{{ drug.priority }}</td>
              <td>{{ Math.round(drug.qty) }}</td>
              <td><a :href="drug.link" target="_blank">{{ drug.slug }}</a></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import api from '@/api';
import VueLadda from 'vue-ladda/src/vue-ladda.vue';
import Export2Excel from '@/Export2Excel';

export default {
  components: {
    VueLadda,
  },
  data() {
    return {
      sites: null,
      selectedSite: null,
      loading: false,
      storeRequest: 1,
      color: '#007dcc',
      drugs: null,
      exportTypes: null,
      exportType: 'xlsx',
    }
  },
  mounted() {
    this.exportTypes = Export2Excel.formats;
  },
  created() {
    this.getSitesData();
  },
  methods: {
    exportExcelToFile() {
      if (!this.drugs) return;
      const tHeader = ['', 'ID', 'Препарат', 'Наличие', 'Приоритет', 'Link'];

      let data = [];
      this.sortBy(this.drugs).forEach((drug, index) => {
        data.push([index + 1, drug.id, drug.drug, Math.round(drug.qty), drug.priority, drug.link]);
      });

      Export2Excel.export_json_to_excel({
        header: tHeader,
        data: data,
        // data: [[1, 'www'], [2, 'eee']],
        filename: 'export_' + this.selectedSite,
        autoWidth: true,
        bookType: this.exportType
      })
    },
    sortBy(drugs) {
      let sorted = _.orderBy(drugs, 'drug');
      // if (request) {
      //     sorted = sorted.filter(x => request[x.id])
      // }
      return sorted
    },
    async getDrugsFromSite() {
      this.loading = true;
      this.drugs = null;
      let {data} = await api.store('/drugs/getDrugsFromSites', {
        site: this.selectedSite,
        storeRequest: this.storeRequest,
      });

      if (data.success) {
        this.drugs = data.drugs;
      } else {
        toastr['warning'](data.message || 'ошибка');
      }
      this.loading = false;
    },
    async getSitesData() {
      let {data} = await api.index('/settings/getSites');
      this.sites = data.sites;
      this.selectedSite = Object.keys(this.sites)[0];
    }
  }
}

</script>

<style scoped>

.table td {
  padding: 3px;
}

</style>
